<template>
    <div class="paragraph" :style="style">
        <div v-for="n in lines" :key="n" class="skeleton line"/>
    </div>
</template>
<script>
export default {
    name: 'SkeletonText',
    props: {
        lines: {
            type: Number,
            default: 4,
        },
        size: {
            type: Number,
            default: 1,
        },
        center: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        style () {
            const style = {};

            if (this.size) {
                style.width = `${100 * this.size}%`;
            }

            if (this.center) {
                style.margin = '0 auto';
            }

            return style;
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/colors';

.paragraph {
    > .line {
        margin: 16px 0;
        height: 14px;

        &:last-child:not(:only-child) {
            width: 80%;
        }
    }
}
</style>
